var _filter, _mask, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFuelingProcess = function SvgFuelingProcess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 103,
    width: 100,
    x: 0,
    y: -3
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 100,
    maskUnits: "userSpaceOnUse",
    width: 100,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "#fff",
    r: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "#ffc72c",
    r: 50
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.478 65.2186h16.3043 11.9566c0 11.2902 2.4018 15.6749 5.9537 20.3041 3.9712 5.1755 8.1767 10.6565 8.1767 26.4353h-26.0869-19.5653c0-15.7789-.7102-21.2598 3.261-26.4353 3.5519-4.6292-.0001-9.0139-.0001-20.3041z",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.6525 29.3467h26.0869v35.8695h-26.0869z",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.2609 65.2186h5.4347 11.9566c0 11.2902 2.4018 15.6749 5.9537 20.3041 3.9712 5.1755 8.1768 10.6565 8.1768 26.4353h-26.087-19.5652c0-15.7789 4.2055-21.2598 8.1767-26.4353 3.552-4.6292 5.9537-9.0139 5.9537-20.3041z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.261 29.3467h17.3913v35.8695h-17.3913z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.0865 54.3467h18.4783v29.3478h-14.1304-4.3479z",
    fill: "#e4002a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.4348 54.3467h9.7826v6.5217c0 1.2006-.9733 2.1739-2.1739 2.1739h-5.4348c-1.2006 0-2.1739-.9733-2.1739-2.1739z",
    fill: "#a6001f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.0865 54.3467h15.2174v-25h-15.2174z",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.0865 39.1305 15.2174-2.1739v-7.6087h-15.2174z",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m36.4128 87.7706v-58.4239h2.174v58.4239c0 4.0521 3.2848 7.337 7.3369 7.337s7.337-3.2849 7.337-7.337v-11.1413h2.1739v11.1413c0 5.2527-4.2582 9.5109-9.5109 9.5109s-9.5109-4.2582-9.5109-9.5109z",
    fill: "#a6001f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.4344 67.3913v9.7826h-4.3479v-5.9782l2.7174-3.2609-2.7174-3.2609v-2.1739z",
    fill: "#a6001f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7391 19.5646c0-1.2006.9733-2.1739 2.1739-2.1739h52.174c1.2006 0 2.1739.9733 2.1739 2.1739v9.7826c0 1.2007-.9733 2.174-2.1739 2.174h-52.1739c-1.2007 0-2.174-.9733-2.174-2.174z",
    fill: "#e4002a"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelingProcess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fueling-process.c20e28121ae6b45d0f740fc3e57e0ea1.svg";